export enum FavouritesStyle {
  TEXT = "TEXT",
  FILLED = "FILLED",
  GRID = "GRID",
}
